(function (Drupal, once) {
  'use strict';

  const FORM_SELECTOR = '#views-exposed-form-catalog-page-standard';
  let currentGroup = '';

  // Keep Drupal.t literal in the bundle: esbuild renames the local Drupal
  // parameter, while Locale's extractor requires the original identifier.
  const GROUPS = [
    { key: 'topic', label: window.Drupal.t('Topics', {}, { context: 'Catalog filter categories' }), selector: '.form-item-topic' },
    { key: 'series', label: window.Drupal.t('Series', {}, { context: 'Catalog filter categories' }), selector: '.form-item-series' },
    { key: 'format', label: window.Drupal.t('Format', {}, { context: 'Catalog filter categories' }), selector: '.form-item-format' },
    { key: 'license', label: window.Drupal.t('Access', {}, { context: 'Catalog filter categories' }), selector: '.form-item-license' },
    { key: 'textlanguage', label: window.Drupal.t('Languages', {}, { context: 'Catalog filter categories' }), selector: '.form-item-textlanguage' },
  ];

  /**
   * Returns whether a filter group currently has a non-All value.
   */
  function groupHasValue(form, key) {
    const input = form.querySelector(`[name="${key}"]`);

    return Boolean(
      input &&
      input.value &&
      input.value !== 'All'
    );
  }

  /**
   * Updates active group and visual state.
   */
  function setActiveGroup(form, key) {
    form.dataset.mobileFilterGroup = key;
    currentGroup = key;

    const index = GROUPS.findIndex((group) => group.key === key);
    const catalog = Drupal.adocsCatalog;
    const resetRow = catalog.active(catalog.getState()) ? 1 : 0;
    form.style.setProperty('--catalog-filter-row-index', String(Math.max(0, index) + resetRow));
    form.querySelectorAll('.is-mobile-active').forEach((panel) => {
      panel.classList.remove('is-mobile-active');
    });
    const group = GROUPS[index];
    const panel = group && form.querySelector(group.selector);
    if (panel) {
      panel.classList.add('is-mobile-active');
      panel.closest('.catalog-filters__cell')?.classList.add('is-mobile-active');
    }

    form
      .querySelectorAll('.catalog-filter-mobile-nav__button')
      .forEach((button) => {
        if (!button.dataset.filterGroup) {
          return;
        }
        const active = button.dataset.filterGroup === key;

        button.classList.toggle('is-active', active);
        button.setAttribute(
          'aria-pressed',
          String(active)
        );
      });
  }

  /**
   * Updates parent classes and reset visibility for the current filters.
   */
  function updateActiveState(form) {
    const catalog = Drupal.adocsCatalog;
    const reset = form.querySelector('.filter-reset');
    if (reset) {
      const hideReset = !catalog.active(catalog.getState());
      if (hideReset && document.activeElement === reset) {
        (form.querySelector('.catalog-filter-mobile-nav__button.is-active')
          || form.querySelector('.catalog-filter-mobile-nav__button[data-filter-group]'))?.focus();
      }
      reset.hidden = hideReset;
    }
    setActiveGroup(form, currentGroup);

    GROUPS.forEach((group) => {
      const button = form.querySelector(
        `.catalog-filter-mobile-nav__button[data-filter-group="${group.key}"]`
      );

      if (!button) {
        return;
      }

      button.classList.toggle(
        'has-active-filter',
        groupHasValue(form, group.key)
      );
    });

    const badgeButton = form.querySelector(
      '.catalog-filter-mobile-nav__badge'
    );

    if (badgeButton) {
      const selected = groupHasValue(form, 'badge');
      badgeButton.classList.toggle(
        'is-selected',
        selected
      );
      badgeButton.setAttribute('aria-pressed', String(selected));
    }
  }

  /**
   * Creates mobile navigation.
   */
  function createNavigation(form) {
    const inline = form.querySelector('.catalog-filters');

    if (!inline) {
      return;
    }

    const nav = document.createElement('nav');
    nav.className = 'catalog-filter-mobile-nav';
    nav.setAttribute('aria-label', window.Drupal.t('Filter categories'));

    const reset = document.createElement('button');
    reset.type = 'button';
    reset.className = 'catalog-filter-mobile-nav__button filter-reset';
    reset.textContent = 'RESET FILTER';
    reset.addEventListener('click', () => {
      const catalog = Drupal.adocsCatalog;
      if (catalog.active(catalog.getState())) catalog.reset();
    });
    nav.appendChild(reset);

    GROUPS.forEach((group) => {
      const button = document.createElement('button');

      button.type = 'button';
      button.className = 'catalog-filter-mobile-nav__button';
      button.dataset.filterGroup = group.key;
      button.setAttribute('aria-pressed', 'false');

      const panel = form.querySelector(group.selector);
      if (panel) {
        panel.id ||= `catalog-filter-panel-${group.key}`;
        button.setAttribute('aria-controls', panel.id);
      }

      const label = document.createElement('span');
      // Literal window.Drupal.t() calls above also make these labels discoverable
      // by Locale's JavaScript translation extractor.
      label.textContent = group.label;

      button.appendChild(label);

      button.addEventListener('click', () => {
        setActiveGroup(form, group.key);
      });

      nav.appendChild(button);
    });

    /*
     * "Neu" contains only one meaningful value, so don't open
     * a detail panel for it. Trigger the existing BEF link instead.
     */
    const badgeButton = document.createElement('button');

    badgeButton.type = 'button';
    badgeButton.className =
      'catalog-filter-mobile-nav__button catalog-filter-mobile-nav__badge';
    badgeButton.textContent = form.querySelector(
      '.form-item-badge a.bef-link:not([data-bef-value="All"])'
    )?.textContent.trim() || window.Drupal.t('New');

    badgeButton.addEventListener('click', () => {
      setActiveGroup(form, '');
      const badgeLink = form.querySelector(
        '.form-item-badge a.bef-link:not([data-bef-value="All"])'
      );

      if (badgeLink) {
        badgeLink.click();
      }
    });

    nav.appendChild(badgeButton);

    inline.prepend(nav);

    updateActiveState(form);
    form.addEventListener('adocs:catalog-open', () => setActiveGroup(form, ''));
    form.addEventListener('adocs:catalog-state', () => updateActiveState(form));
  }

  Drupal.behaviors.catalogFilterMobile = {
    attach(context) {
      once(
        'catalog-filter-mobile',
        FORM_SELECTOR,
        context
      ).forEach((form) => {
        createNavigation(form);
      });

      /*
       * The form may be updated through Views AJAX.
       * Refresh visual states on every behavior attach.
       */
      const form = document.querySelector(FORM_SELECTOR);

      if (form) {
        updateActiveState(form);
        document.documentElement.classList.remove('catalog-return-initializing');
      }
    },
  };
})(Drupal, once);
